import PrintableBox from './PrintableBox';

export default PrintableBox;
